import type { FaireProductEntity } from "../../entity_types/product";

export const p_cufca9pp6x: FaireProductEntity = {
  token: "p_cufca9pp6x",
  type: "product",
  name: "Cotton Striped Boho Hippie Lightweight Pants",
  brandToken: "b_ch3tzpim",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/48a3de5172cc7ce408e9060bf3565d13c38caf08877b220de6310060a1bfe65e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3be231a55fca0827534ae0074aca39c3df82526f5b2535001c7282b22dcb9b86.jpeg",
    "https://cdn.faire.com/fastly/dc4639dff400344c1352917f21e855e59bef745e8e26ee55f05b9966f3253a19.jpeg",
    "https://cdn.faire.com/fastly/0e93420b8da2a212774461c85979959b826c455376e5d368f6a5c16cbc8fb353.jpeg",
    "https://cdn.faire.com/fastly/7988c641a99c8fb9fcb0b641525469fdef689126a6a3ee2f41df7336a86adb49.jpeg",
    "https://cdn.faire.com/fastly/c29cc946e7f9189ebdfc8f735e3ff24aad6e86f7acaae6747d11ab831a60556a.jpeg",
    "https://cdn.faire.com/fastly/32e96f87098b7e163fc525ef0d8adf9bb0e191b75cce29bcb8b2618cad76d7b6.jpeg",
    "https://cdn.faire.com/fastly/96dfa8da872f3f2044f6eb214cfbe32ba7293aaa7e5aa903809c303c85eb3a7a.jpeg",
    "https://cdn.faire.com/fastly/0de28776902ddb1314c3ec4407cc3801642ff9e4b8a7553d25812ec2c4f0df0b.jpeg",
    "https://cdn.faire.com/fastly/c55e86c62bef9e2a2de7d5ebfc97ef45692f0987886c5cd1f8af7e239ccb5b7e.jpeg",
  ],
  priceDollars: 15.25,
  description:
    "Cotton Striped hippie pant, meticulously crafted to perfection in Nepal. These pants are  from high-quality Cotton, ensuring both comfort and durability. The unique style adds a touch of uniqueness and artistic flair to each pair. With their unique style, these pants offer a blend of style and freedom of movement. Perfect for casual occasion, they are versatile and effortlessly chic. By offering our exceptional bohemian harem pants, you can provide your customers with a fashion-forward bohemian trend hippie boho clothing and ethically made choice. ",
  tags: [],
  msrpDollars: 30.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:22.489Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
